module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/esmeralda_goober_proud-8cbef198ed6fd9fc4fa28a700b2d5f24.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/esmeralda_goober_proud.png
// module id = 446
// module chunks = 2